var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdtLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    id: "usdt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75,49.78V37.27h28.46V17.53h-79V37.27H53V49.78c-23.91,1.15-41.86,5.95-41.86,11.7S29.07,72,53,73.18v41.29H75V73.18c23.91-1.14,41.86-5.94,41.86-11.7S98.93,50.93,75,49.78ZM64,69.44c-25.89,0-46.88-4-46.88-8.82,0-4.15,15.29-7.63,35.86-8.56V66.19c3.54.16,7.22.25,11,.25s7.48-.09,11-.25V52.06c20.57.93,35.86,4.41,35.86,8.56C110.88,65.49,89.89,69.44,64,69.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtLogo);
export default __webpack_public_path__ + "static/media/usdt-logo.d5f5b4d6b79e8a27aae626a0b3f364dc.svg";
export { ForwardRef as ReactComponent };